import { setHours, setMilliseconds, setMinutes, setSeconds } from 'date-fns/fp';
import * as R from 'ramda';

export const resetDate = (date = new Date()): Date => {
  return R.compose(setMilliseconds(0), setSeconds(0), setMinutes(0), setHours(0))(date);
};
